angular.module("componentes").directive("numberFieldV3", function () {
	"use strict";

	return {
		scope: true,
		controller: "NumberFieldV3Ctrl",
		controllerAs: "ctrl",
		//transclude: true,
		replace: true,
		templateUrl: "componentes/angular-material/custom/fields/numberField/numberFieldV3_template.html",
		bindToController: {
			label: "@",
			name: "@",
			isDisabled: "=",
			isRequired: "=",
			type: "@",
			decimals: "=?",
			field: "=",
			error: "=",
			mask: "@?",
			min: "@?",
			maxlength: "@?",
			max: "@?",
			onBlur: "=?"
		},
		link: function (scope, element, attrs) {
			if (scope && !scope.ctrl.min) {
				scope.ctrl.min = 0;
			}
		}
	};
});
